(function() {

    'use strict';

     eclipseApp.directive('embarrassingModal', [ 'uteModal', function (uteModal) {

       return {
         restrict: 'A',
         scope: true,
         link: function (scope, element, attrs) {

           function embarrassingModalCheck () {
             uteModal.open({
               templateUrl: 'modules/my-account/embarrassing-modal.html',
               ok: function () {
                // Any Business logic on click of OK button goes here
               },
               cancel: function () {
               // Any Business logic on click of Cancel button goes here
               },
               controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                 $scope.show611Content = false;
                 $scope.show234Content = false;
                 $scope.isPrepaid = false;
                 $scope.isPostpaid = false;
                 $scope.isCMSContent = false;
                 $scope.flowName = null;

                 if(attrs.displayContent == '6-1-1'){
                   $scope.show611Content = true;
                 } else if(attrs.displayContent == '2-3-4'){
                   $scope.show234Content = true;
                 }else if(attrs.displayContent == 'cms'){
                   $scope.isCMSContent = true;
                 }

                 if(attrs.flowType == 'prepaid'){
                   $scope.isPrepaid = true;
                 }else if(attrs.flowType == 'postpaid'){
                   $scope.isPostpaid = true;
                 }

                 if(attrs.flowName != '' && attrs.flowName != null){
                   $scope.flowName = attrs.flowName;
                 }

                 $scope.close = function(){
                   $modalInstance.close();
                 };
                 $scope.ok = function () {
                   $modalInstance.close();
                 };
                 $scope.cancel = function () {
                   $modalInstance.dismiss('cancel');
                 };
               }]
             });
           }

           element.bind('click', embarrassingModalCheck);
         }
       };
     }]);

})();

